<template>
  <v-data-table
    :headers="headers"
    class="elevation-1"
    :items="ads"
    :loading="loading"
    :options.sync="tableOptions"
    :server-items-length="totalItems"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50],
      'show-first-last-page': true,
    }"
    :sort-by="sortKey"
    :sort-desc="sortDesc"
    must-sort
  >
    <template #top>
      <h1>Previous Ads</h1>
    </template>

    <template #item.productId="{ item, value }">
      <router-link
        v-if="!!value"
        class="default-btn link"
        :to="{ name: 'OrganizationProductsEdit', params: {
          organizationId: item.organizationId,
          productId: value,
        }}"
      >{{ getProductName(value) }}</router-link>
    </template>

    <template #item.type="{ value }">
      <template v-if="value === 'match_loan_none'">Match | No Preference</template>
      <template v-if="value === 'match_loan_conv'">Match | Conventional Loan</template>
      <template v-if="value === 'match_loan_sba'">Match | SBA Loan</template>
      <template v-if="value === 'resource_amortization'">Amortization Calculator</template>
    </template>

    <template #item.createdAt="{ value }">
      {{ value | date }}
    </template>

    <template #item.updatedAt="{ value }">
      {{ value | date }}
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ArchivedAdsTable',

  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    ads: [],
    loading: false,

    headers: [
      { text: 'Product', value: 'productId' },
      { text: 'Type', value: 'type' },
      { text: 'Displayed to users', value: 'displayCount' },
      { text: 'Resulted in active lead', value: 'leadCount' },
      { text: 'Last Updated', value: 'updatedAt' },
      { text: 'Last Created', value: 'createdAt' },
    ],

    tableOptions: {},
    totalItems: 0,

    sortKey: 'createdAt',
    sortDesc: true,

    query: {
      active: false,
      $limit: 10,
      $skip: 0,
      $paginate: true,
      $sort: { createdAt: -1 },
    },
  }),

  computed: {
    ...mapGetters('feathers', ['apiAds']),
  },

  watch: {
    tableOptions (newVal, oldVal) {
      this.getAds()

      if (newVal.itemsPerPage !== oldVal.itemsPerPage) {
        this.tableOptions.page = 1
      }

      this.query.$limit = this.tableOptions.itemsPerPage
      this.query.$skip = this.tableOptions.itemsPerPage * (this.tableOptions.page - 1)
      this.query.$sort = {
        [this.tableOptions.sortBy]: this.tableOptions.sortDesc ? -1 : 1,
      }
    },
  },

  created () {
    this.getAds()
  },

  methods: {
    async getAds () {
      this.loading = true

      const response = await this.apiAds.find({ query: this.query })

      this.totalItems = response.total
      this.ads = response.data

      this.loading = false
    },

    getProductName (id) {
      const product = this.products.find(product => product.id === id)

      return product
        ? product.internalName || product.title
        : ''
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
